import { z } from "zod";

const sourcepointPropertySchema = z
  .object({
    account_id: z.number().int(),
    property_id: z.number().int().optional(),
    property_href: z.string(),
    base_endpoint: z.string(),
  })
  .strict();

const consentDataSchema = z
  .object({
    uuid: z.string().optional(),
    applies: z.boolean().optional(),
    consent_string: z.string().optional(),
    uuid_source: z.string().optional(),
    consent_string_source: z.string().optional(),
    applies_source: z.string().optional(),
  })
  .strict();

const usnatConsentDataSchema = z
  .object({
    uuid: z.string().optional(),
    applies: z.boolean().optional(),
    consent_string: z.string().optional(),
    gpc_enabled: z.boolean().optional(),
    uuid_source: z.string().optional(),
    consent_string_source: z.string().optional(),
    applies_source: z.string().optional(),
    gpc_enabled_source: z.string().optional(),
  })
  .strict();

const userIdSchema = z
  .object({
    type: z.enum(["TYPE_UNSPECIFIED", "TYPE_GA", "TYPE_HYBRID"]),
    value: z.string(),
  })
  .strict();

const pageContextSchema = z
  .object({
    url: z.string(),
    hostname: z.string(),
    path: z.string(),
    referrer: z.string(),
  })
  .strict();

const callbackDataSchema = z
  .object({
    choice_id: z.string(),
    choice_type_id: z.string(),
    info_json: z.string(),
  })
  .strict();

export const sourcepointConsentCapturedEventSchema = z
  .object({
    event_id: z.string(),
    captured_at: z.string().datetime(),
    trigger: z.enum([
      "CONSENT_EVENT_TRIGGER_UNSPECIFIED",
      "CONSENT_EVENT_TRIGGER_ON_CONSENT_READY",
      "CONSENT_EVENT_TRIGGER_ON_MESSAGE_CHOICE_SELECT",
    ]),
    message_type: z.string(),
    sourcepoint: sourcepointPropertySchema,
    gdpr: consentDataSchema,
    usnat: usnatConsentDataSchema,
    user_ids: z.array(userIdSchema),
    page: pageContextSchema,
    callback_data: callbackDataSchema,
  })
  .strict();

export default sourcepointConsentCapturedEventSchema;

export type SourcepointConsentCapturedEventPayload = z.infer<
  typeof sourcepointConsentCapturedEventSchema
>;
